import React from 'react';
import { Box, Flex, DeprecatedIcon, Middot, Text } from '@fullstory/components';
import { getDateStringFromRange, getFormattedRollingWindowString } from '../../utils';
import { TimeRange } from '@fullstory/proto/fs/api/segment';
import { TrendFrequency } from '@fullstory/proto/fs/services/search-settings/visualizationsettings';
import { intl } from '@fullstory/intl';
import { RollingWindow } from '../../types';

const frequencyToLabelMap = {
  [TrendFrequency.TREND_FREQUENCY_MINUTELY]: intl.formatMessage({
    defaultMessage: 'Every Minute',
    id: 'FoVRBo',
  }),
  [TrendFrequency.TREND_FREQUENCY_HOURLY]: intl.formatMessage({
    defaultMessage: 'Hourly',
    id: 'Kj+Lfx',
  }),
  [TrendFrequency.TREND_FREQUENCY_DAILY]: intl.formatMessage({
    defaultMessage: 'Daily',
    id: 'zxvhnE',
  }),
  [TrendFrequency.TREND_FREQUENCY_WEEKLY]: intl.formatMessage({
    defaultMessage: 'Weekly',
    id: '/clOBU',
  }),
  [TrendFrequency.TREND_FREQUENCY_MONTHLY]: intl.formatMessage({
    defaultMessage: 'Monthly',
    id: 'wYsv4Z',
  }),
};

export const TimeRangeDisplay: React.FC<{
  timeRange: TimeRange | null | undefined;
  frequency: TrendFrequency | null;
  rollingWindow?: RollingWindow;
}> = ({ timeRange, frequency, rollingWindow }) => {
  if (!timeRange && !frequency) return <></>;
  const rollingWindowText = rollingWindow ? getFormattedRollingWindowString(rollingWindow) : '';

  return (
    <Box data-component="TimeRangeDisplay" marginBottom={8}>
      <Text appearance="bodySmall" tag="div">
        <Flex justifyContent="flex-start">
          <Box paddingRight={8}>
            <DeprecatedIcon name="dashboards/calendar" color="neutrals-n7" size={20} />
          </Box>
          {rollingWindowText && (
            <>
              {rollingWindowText}
              <Middot />
            </>
          )}
          {frequency && <>{frequencyToLabelMap[frequency]}</>}
          {frequency && timeRange && <Middot />}
          {timeRange && (
            <>
              {getDateStringFromRange({
                Start: timeRange?.startTime || '',
                End: timeRange?.endTime || '',
              })}
            </>
          )}
        </Flex>
      </Text>
    </Box>
  );
};
